module.exports = __webpack_public_path__ + "img/upload_image.6f396529.svg";